var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('img',{attrs:{"src":require("../../assets/images/learning-card/1.png")},on:{"click":function($event){$event.preventDefault();}}}),(_vm.bought)?_c('h3',[_vm._v("有效期 "+_vm._s(_vm.format(_vm.startDate))+"-"+_vm._s(_vm.format(_vm.endDate)))]):_c('h3',[_vm._v("有效期一年")])])
}
var staticRenderFns = []

export { render, staticRenderFns }